import type { PageContext } from 'vike/types'
const routeRegex = /\/(buy|rent)\/tags\/([^/]+)(?:\/page\/(\d+))?/
export function route(pageContext: PageContext) {
  const match = pageContext.urlPathname.match(routeRegex)
  if (!match) return false
  const [, mode, tag, page] = match
  const path = `/${mode}/tags/${tag}`
  return {
    precedence: 2,
    routeParams: { mode, tag, path: path.replace(/^\//, ''), page: page || '1' }
  }
}
